/** QAInput 布局常量，与 styles/_qa-input-tokens.scss 保持同步 */
export const QA_INPUT_PADDING_PX = 16;
export const QA_INPUT_SECTION_GAP_PX = 10;
export const QA_INPUT_FOOTER_MIN_HEIGHT_PX = 32;
/** 外壳总高（Home / ChatPage / Copilot 统一） */
export const QA_INPUT_OUTER_MIN_HEIGHT_PX = 125;

export const QA_INPUT_EDITOR_MIN_HEIGHT_PX =
  QA_INPUT_OUTER_MIN_HEIGHT_PX
  - QA_INPUT_PADDING_PX * 2
  - QA_INPUT_SECTION_GAP_PX
  - QA_INPUT_FOOTER_MIN_HEIGHT_PX;

export const QA_INPUT_DEFAULT_EDITOR_MIN_HEIGHT = `${QA_INPUT_EDITOR_MIN_HEIGHT_PX}px`;
